import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Form } from "components/Form";
import { Field } from "components/Field";
import { PasswordInput } from "components/PasswordInput";
import { Button } from "components/Button";
import { Small } from "components/Small";
import { Spacer } from "components/Spacer";

export function CreateNewPasswordForm({ onSubmit }) {
  const { t } = useTranslation();

  const renderForm = useCallback(
    ({ values, errors, onChange }) => {
      return (
        <>
          <Field
            label={t("field.password")}
            htmlFor="password"
            error={errors.password}
          >
            <PasswordInput
              id="password"
              name="password"
              value={values.password}
              onChange={onChange}
              isStrengthEnabled
            />
          </Field>

          <Field
            label={t("field.passwordConfirm")}
            htmlFor="passwordConfirm"
            error={errors.passwordConfirm}
          >
            <PasswordInput
              id="passwordConfirm"
              name="passwordConfirm"
              value={values.passwordConfirm}
              onChange={onChange}
            />
          </Field>
          {
            <Small>{t("pageSignUp.passwordHelper")}</Small>
          }
          <Spacer />

          <Field>
            <Button block type="submit" variant="primary" shape="round">
              {t("action.continue")}
            </Button>
          </Field>
        </>
      );
    },
    [t],
  );

  const validationRules = useMemo(() => {
    return [
      {
        field: "password",
        isValid: (value) => typeof value === "string" && value.length > 0,
        error: t("error.passwordRequired"),
      },
      {
        field: "password",
        isValid: (value) => typeof value === "string" && value.length >= 8,
        error: t("error.passwordMustBeLonger"),
      },
      {
        field: "password",
        isValid: (value) => /[!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]/.test(value),
        error: t("error.passwordMustContainSymbol"),
      },
      {
        field: "password",
        isValid: (value) => /\d/.test(value),
        error: t("error.passwordMustContainNumber"),
      },
      {
        field: "passwordConfirm",
        isValid: (value) => typeof value === "string" && value.length > 0,
        error: t("error.passwordConfirmationRequired"),
      },
      {
        field: "passwordConfirm",
        isValid: (value, form) => value === form.password,
        error: t("error.passwordsNotMatch"),
      },
    ];
  }, [t]);

  return (
    <Form
      validationRules={validationRules}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {renderForm}
    </Form>
  );
}

const initialValues = {
  password: "",
  passwordConfirm: "",
};
